export default "__VITE_ASSET__DTx8XmCO__"